export function initFooterLanguage() {
  const footerLang = document.querySelector(".footer-lang");

  if (!footerLang) return;

  const languageList = footerLang.querySelector(".language-list");
  const currentLang = footerLang.querySelector(".current-language");

  // Toggle dropdown
  footerLang.addEventListener("click", function (e) {
    e.stopPropagation();
    languageList.classList.toggle("show");
  });

  // Change language
  languageList.querySelectorAll("a").forEach((item) => {
    item.addEventListener("click", function (e) {
      // e.preventDefault();
      e.stopPropagation();

      currentLang.textContent = this.textContent;
      languageList.classList.remove("show");
    });
  });

  // Close on outside click
  document.addEventListener("click", function () {
    languageList.classList.remove("show");
  });
}
